import { Gender } from './gender';
import { Nationality } from './nationality';
import { EtcStudentParentLanguage } from './etc-student-parent-language';
import { Moment } from 'moment';
import { Booking } from './booking';

export class EtcParentalPermission {

    constructor(
        public studentFirstName: string,
        public studentFamilyName: string,
        public studentGender: Gender,
        public studentNationality: Nationality,
        public studentFirstLanguage: EtcStudentParentLanguage,
        public studentDateOfBirth: Moment,
        public studentPassportNumber: string,
        public studentPassportExpiryDate: Moment,
        public parent1Title: string,
        public parent1FirstName: string,
        public parent1FamilyName: string,
        public parent1RelationshipToStudent: string,
        public parent1FirstLanguage: EtcStudentParentLanguage,
        public parent1LevelOfEnglish: string,
        public parent1Address: string,
        public parent1MobileNumber: string,
        public parent1Email: string,
        public parent2Title: string,
        public parent2FirstName: string,
        public parent2FamilyName: string,
        public parent2RelationshipToStudent: string,
        public parent2FirstLanguage: EtcStudentParentLanguage,
        public parent2LevelOfEnglish: string,
        public parent2Address: string,
        public parent2MobileNumber: string,
        public parent2Email: string,
        public permitMedicalTreatment: boolean,
        public confirmAllMedicalProblemDisclosure: boolean,
        public extraMedicalProblemDetail: string,
        public permitParticipationToJuniorActivity: boolean,
        public confirm16To17ActivityConditions: boolean,
        public allowPublishingPrintMaterial: boolean,
        public allowPublishingSocialMedia: boolean,
        public allowPublishingVideos: boolean,
        public allowPublishingEtcWebsite: boolean,
        public makeOwnTransportFromAccommodationToSchool: boolean,
        public makeOwnTransportFromAndToAirport: boolean,
        public allowPublicTransport: boolean,
        public agreeToFollowAccommodationRules: boolean,
        public stayInHomestayAccommodation: boolean,
        public stayInResidentialAccommodation: boolean,
        public stayInOwnAccommodation: boolean,
        public ownAccommodationResponsibleName: string,
        public ownAccommodationResponsibleBirthDate: Moment,
        public ownAccommodationResponsibleRelationshipToChild: string,
        public ownAccommodationResponsibleAddress: string,
        public ownAccommodationResponsiblePhoneNumber: string,
        public ownAccommodationResponsibleEmail: string,
        public lastTetanusInjectionDate: Moment,
        public allowJoiningClassWithOver18: boolean,
        public allowGoingOutUnsupervised: boolean,
        public doctorTitle: string,
        public doctorFirstName: string,
        public doctorFamilyName: string,
        public doctorAddress: string,
        public doctorPhoneNumber: string,
        public doctorEmail: string,
        public allowRegisteringChildWithDoctor: boolean,
        public parentalResponsibleFullName: string,
        public parentalResponsiblePhoneNumber: string,
        public parentalResponsibleRelationshipToStudent: string,
        public parentalResponsibleFullAddress: string,
        public parentalSignature: string,
        public booking: Booking,
        public id?: number
    ){}
}
